var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternetOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 16.556c0 9.129 7.427 16.556 16.556 16.556v-21.01L5 16.557z",
    fill: "#9AC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.556 12.103v21.009c9.129 0 16.556-7.427 16.556-16.556l-16.556-4.453z",
    fill: "#4A82C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.112 16.556C38.112 7.427 30.685 0 21.556 0v16.556h16.556z",
    fill: "#68A0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.556 0C12.427 0 5 7.427 5 16.556h16.556V0z",
    fill: "#B9D7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.834 16.556c0 9.129-3.713 16.556-8.278 16.556l-4.453-19.896h8.592l4.139 3.34z",
    fill: "#68A0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.556 0c4.565 0 8.278 7.427 8.278 16.556H18.216L21.556 0z",
    fill: "#88B9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.278 16.556c0 9.129 3.714 16.556 8.278 16.556V16.556l-4.139-3.34-4.139 3.34z",
    fill: "#88B9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.556 0c-4.564 0-8.278 7.427-8.278 16.556h8.278V0z",
    fill: "#9AC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.19 32.673-8.28-14.342a3.518 3.518 0 0 0-3.076-1.775l-4.453 10.722L29.834 38h8.28c2.734 0 4.443-2.96 3.076-5.327z",
    fill: "#BA1232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.759 18.331-8.28 14.342C17.11 35.041 18.818 38 21.552 38h8.281V16.556a3.518 3.518 0 0 0-3.075 1.775z",
    fill: "#DA2346"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E6E6",
    d: "M30.947 34.381h-1.113l-.557-1.113.557-1.114h1.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28.72 32.154h1.114v2.227h-1.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E6E6",
    d: "M30.947 29.928h-1.113l-.557-3.888.557-3.888h1.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28.72 22.152h1.114v7.776h-1.113z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetOff);
export default __webpack_public_path__ + "static/media/internet-off.3c95baabac7565e65a3eda7e4ffa759b.svg";
export { ForwardRef as ReactComponent };